import React, { useEffect, useState } from 'react';
import { Col, Row, Tooltip } from 'antd';
import { DataTable, InfoMessage } from 'components';
import {
  columnsPillarAGreenTransitionsTable,
} from '../../config';
import { useSelector } from 'react-redux';
import merge from 'lodash/merge';
import keyBy from 'lodash/keyBy';
import filter from 'lodash/filter';
import cloneDeep from 'lodash/cloneDeep';
import { ReactComponent as Info } from 'assets/icons/info-icon.svg';
import styles from './SubTabPlan3.module.scss';
// import { parseCurrency } from 'utils/helpers';

const SubTabPlan3 = () => {

  const excelData = useSelector(state => state.forms?.carrier?.dapanesEpendysis);
  const [businessPlanDetails, setBusinessPlanDetails] = useState("");

  useEffect(()=>{
    if(excelData){
      setBusinessPlanDetails(JSON.parse(excelData));
    } else {
      setBusinessPlanDetails("");
    }
  },[excelData]);

  const pillarADatasource = merge(
    cloneDeep(
      keyBy(
        businessPlanDetails
          ? businessPlanDetails.proupologismosEpendytikouSxediou.map((item, index) => ({
              ...item,
              uniqueKey: `${item.ependytikiDapani}_${index}`
            }))
          : [],
        'uniqueKey'
      )
    ),
  );

  // const pillarADatasource = cloneDeep(
  //   (businessPlanDetails?.proupologismosEpendytikouSxediou || []).filter(
  //     (item) => item.kostosAgoras !== 0
  //   )
  // );

  let pillarAColumns = columnsPillarAGreenTransitionsTable;

  //TO BE TESTED->
  const filteredData = filter(pillarADatasource, function (value) {
    return (
      value?.hasOwnProperty('ependytikiDapani') &&
      value.ependytikiDapani !== ''
    );
  });
  
  const totalKostosAgoras = filteredData.reduce(
    (acc, curr) => acc + (parseFloat(curr.kostosAgoras) || 0),
    0
  );
  
  // Append summary row
  const dataSourceWithSummary = [
    ...filteredData.map((d, index) => ({
      ...d,
      key: index,
    })),
    {
      key: 'summary',
      ependytikiDapani: 'Σύνολο',
      perigrafiEpendytikisDapanis: '',
      kostosAgoras: totalKostosAgoras,
      isSummaryRow: true,
    },
  ];

  return (
    <div className={styles.subTab3}>
      <div className={styles.subTabPlan3Form}>
      <p className="mt-4 mr-0 color-purple-3 text-bold font-size-24">
          Δαπάνες Επένδυσης
        <Tooltip
          placement="bottom"
          // className="ml-1"
          title={
            <div className="tooltip-container">
            <span className="info-icon-content">
              <b>Πως επιλέγεται το πλαίσιο κρατικών ενισχύσεων;</b>
              <br></br>
              Η επιλογή του πλαισίου κρατικής ενίσχυσης γίνεται βάσει των δαπανών που θέλετε να χρηματοδοτήσετε, καθώς και του ύψους της επένδυσης.
            </span>
          </div>
          }
        >
          <Info className="infoIconSmallIban" />
        </Tooltip>
      </p>

      {businessPlanDetails && (
        <>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="busPlanExpenseTable">
              <div className="pt-1 pb-1 pl-0 pr-0">
                <DataTable
                  dataSource={
                    dataSourceWithSummary
                      ? filter(dataSourceWithSummary, function (value, key) {
                          return (
                            value?.hasOwnProperty('ependytikiDapani') &&
                            value?.ependytikiDapani !== ''
                          );
                        }).map((d, index) => ({
                          ...d,
                          key: index,
                        }))
                      : []
                  }
                  columns={pillarAColumns.map(column => ({
                    ...column,
                    title: () => {
                      return column.withInfo ? (
                        <div className="d-flex align-items-center">
                          <div className="mr-1">{column.title}</div>
                          <InfoMessage
                            infoMessage={column.infoMessage}
                            iconClassName={'column-table-info-icon'}
                          />
                        </div>
                      ) : (
                        <div>{column.title}</div>
                      );
                    },
                  }))}
                  pagination={false}
                  className={'table-with-totals-purple'}
                />
              </div>
            </Col>
          </Row>
        </>
      )}
      </div>
    </div>
  );
};

export default SubTabPlan3;
